import { render, staticRenderFns } from "./Platen.vue?vue&type=template&id=34fdb17e&scoped=true"
import script from "./Platen.vue?vue&type=script&lang=js"
export * from "./Platen.vue?vue&type=script&lang=js"
import style0 from "./Platen.vue?vue&type=style&index=0&id=34fdb17e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fdb17e",
  null
  
)

export default component.exports